/**
 * @license
 * MyFonts Webfont Build ID 3867246, 2020-12-16T11:57:38-0500
 *
 * The fonts listed in this notice are subject to the End User License
 * Agreement(s) entered into by the website owner. All other parties are
 * explicitly restricted from using the Licensed Webfonts(s).
 *
 * You may obtain a valid license at the URLs below.
 *
 * Webfont: Neue Helvetica Pro 77 Condensed Bold by Linotype
 * URL: https://www.myfonts.com/collections/linotype-foundry
 *
 * Webfont: Neue Helvetica Pro 57 Condensed by Linotype
 * URL: https://www.myfonts.com/collections/linotype-foundry
 *
 * © 2025 MyFonts Inc.
 */

export const fontsLicense = `
/**
 * @license
 * MyFonts Webfont Build ID 3867246, 2020-12-16T11:57:38-0500
 * 
 * The fonts listed in this notice are subject to the End User License
 * Agreement(s) entered into by the website owner. All other parties are 
 * explicitly restricted from using the Licensed Webfonts(s).
 * 
 * You may obtain a valid license at the URLs below.
 * 
 * Webfont: Neue Helvetica Pro 77 Condensed Bold by Linotype
 * URL: https://www.myfonts.com/collections/linotype-foundry
 
 * Webfont: Neue Helvetica Pro 57 Condensed by Linotype
 * URL: https://www.myfonts.com/collections/linotype-foundry
 * 
 * © 2025 MyFonts Inc.
 */
`;
